import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { LandAreaContainer } from '../../containers/filters/LandAreaContainer';
import { IFilter } from '../../types/filters';

export const landArea: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: LandAreaContainer,
};
